import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const sendTicket = (user , ticketdata) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/ticket/sendticket/' + user, ticketdata , {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'TICKET_EMAIL_SEND',
                payload: data.message
            })
            dispatch({
                type: 'TICKET_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}